import { Component, Inject, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { PATTERN } from "utils/constants";
import { DropDown } from "models";
import {
  SystemSettingsService,
  CityService,
  UtilityService,
  HttpService,
} from "services";
import { Router, ActivatedRoute } from "@angular/router";
import { distinctUntilChanged } from "rxjs/operators";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  templateUrl: "./add-contact.component.html",
  styles: [
    `
      .contain {
        max-height: 60vh;
        overflow-y: auto;
        overflow-x: hidden;
      }
    `,
  ],
})
export class AddContactComponent implements OnInit {
  id = null;
  isProfile = false;
  appearance = "fill";
  baseUrl = "contact/";
  isEditable = false;
  editAccess = this.util.hasEditAccess();

  group: FormGroup;
  level = new FormControl("", Validators.required);
  name = new FormControl("", [
    Validators.required,
    Validators.maxLength(80),
    Validators.pattern("^[a-zA-Z0-9 ,().]*$"),
  ]);
  state = new FormControl("");
  district = new FormControl("");
  ulb = new FormControl("");
  ward = new FormControl("");
  area = new FormControl("");
  zone = new FormControl("");
  address = new FormControl("");
  personalPhoneShow = new FormControl(false);
  designation = new FormControl("", Validators.required);
  officialEmail = new FormControl("", [Validators.required,
    Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
  ]);
  personalEmail = new FormControl("", [
    Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
  ]);
  officialMobile = new FormControl("", [
    Validators.required,
    Validators.pattern(PATTERN.MOBILE),
  ]);
  personalMobile = new FormControl("", [Validators.pattern(PATTERN.MOBILE)]);
  message = new FormControl("");
  officialLandline = new FormControl("");
  facebook = new FormControl("");
  twitter = new FormControl("");
  linkedin = new FormControl("");
  instagram = new FormControl("");
  whatsApp = new FormControl("", [Validators.pattern(PATTERN.MOBILE)]);

  stateOptions: DropDown[] = [];
  districtOptions: DropDown[] = [];
  ulbOptions: DropDown[] = [];
  accessOptions = [];
  wardOptions = [];
  designationOptions = [];
  areaOptions = [];
  zoneOptions = [];

  constructor(
    private fb: FormBuilder,
    private sys: SystemSettingsService,
    private city: CityService,
    public util: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AddContactComponent>
  ) {
    this.createForm();
    this.fetchAccessList();
    this.fetchDesignationList();
    if (this.route.snapshot.paramMap.get("id")) {
      this.id = this.route.snapshot.paramMap.get("id");
      this.getContact(this.id);
    } else {
      this.isEditable = true;
    }
    this.level.valueChanges.subscribe((_) => {
      this.util.setControlsRequired([this.state, this.district, this.ulb]);
      if (this.level.value) {
        if (this.level.value === "STATE") {
          this.util.setControlsRequired([this.state]);
          this.util.removeRequired([
            this.district,
            this.ulb,
            this.ward,
            this.area,
          ]);
        } else if (this.level.value === "DISTRICT") {
          this.util.setControlsRequired([this.state, this.district]);
          this.util.removeRequired([this.ulb, this.ward, this.area]);
        } else if (this.level.value === "ULB") {
          this.util.setControlsRequired([this.state, this.district, this.ulb]);
          this.util.removeRequired([this.ward, this.area]);
        } else if (this.level.value === "WARD") {
          this.util.setControlsRequired([
            this.state,
            this.district,
            this.ulb,
            this.ward,
          ]);
          this.util.removeRequired([this.area]);
        } else if (this.level.value === "AREA") {
          this.util.setControlsRequired([
            this.state,
            this.district,
            this.ulb,
            this.ward,
            this.area,
          ]);
        } else if (this.level.value === "ZONE") {
          this.util.setControlsRequired([this.state, this.district, this.ulb]);
        } else if (this.level.value === "USER") {
          this.util.setControlsRequired([this.state, this.district, this.ulb]);
        } else {
          this.util.removeRequired([this.state, this.district, this.ulb]);
        }
        this.fetchDesignationList({ accessLevel: this.level.value });
      }
      if (
        this.util.getAccessLevel() === "ULB" ||
        this.util.getAccessLevel() === "WARD" ||
        this.util.getAccessLevel() === "AREA" ||
        this.util.getAccessLevel() === "ZONE" ||
        this.util.getAccessLevel() === "USER"
      ) {
        this.util.disableControls([this.state, this.district, this.ulb]);
      }
      if (this.util.getAccessLevel() === "DISTRICT") {
        this.util.disableControls([this.state, this.district]);
      }
      if (this.util.getAccessLevel() === "STATE") {
        this.state.disable();
      }
    });
    sys.getStateDropdown().subscribe((res: any) => {
      if (res.data.length) {
        this.stateOptions = res.data;
        if (res.disable) {
          this.state.setValue(res.data[0].code);
          this.state.disable();
          this.setDistrictValue();
        }
      }
    });
    this.state.valueChanges.pipe(distinctUntilChanged()).subscribe((_) => {
      this.setDistrictValue();
    });
    this.district.valueChanges.pipe(distinctUntilChanged()).subscribe((_) => {
      this.setULBValue();
    });
    this.ulb.valueChanges.pipe(distinctUntilChanged()).subscribe((_) => {
      if (this.ulb.value) {
        this.fetchWardDropdownList(this.ulb.value);
        this.fetchZoneDropdownList(this.ulb.value);
      }
    });
    this.group
      .get("ward")
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((val) => {
        if (val) {
          this.fetchAreaDropdownList(val);
        }
      });
  }
  checkAphaNumeric(evnt) {
    console.log(evnt);
  }
  private getContact(id) {
    this.city.getDetail(this.baseUrl, id).subscribe(
      (res) => {
        if (res.responseCode === 200) {
          this.setData(res.data);
        } else {
          this.back();
          this.util.showMsg(res.responseMessage, "Error");
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  ngOnInit() {
    if (Object.keys(this.data || {}).length) {
      if (this.data.title) {
        this.group.patchValue(this.data);
        this.checkValueAndDisable([
          this.level,
          this.designation,
          this.zone,
          this.state,
          this.district,
          this.ulb,
          this.ward,
          this.area,
        ]);
      }
      if (this.data.contactId) {
        this.id = this.data.contactId;
        this.getContact(this.data.contactId);
      }
      if (this.data.isProfile) {
        this.isProfile = true;
      }
    } else if (this.route.snapshot.paramMap.get("id")) {
      this.isEditable = false;
      this.group.disable();
      this.district.disable();
      this.ulb.disable();
    }
  }
  checkValueAndDisable(controls: FormControl[]) {
    controls.forEach((c: FormControl) => {
      if (c.value) {
        this.util.disableControls([c]);
      }
    });
  }
  setDistrictValue() {
    if (this.state.value) {
      this.sys.getDistrictDropdown(this.state.value).subscribe((res: any) => {
        if (res.data.length) {
          this.districtOptions = res.data;
          if (res.disable) {
            this.district.setValue(res.data[0].code);
            this.district.disable();
            this.setULBValue();
          }
        }
      });
    }
  }

  setULBValue() {
    if (this.district.value) {
      this.sys.getULBDropdown(this.district.value).subscribe((res: any) => {
        if (res.data.length) {
          this.ulbOptions = res.data;
          if (res.disable) {
            this.ulb.setValue(res.data[0].code);
            this.ulb.disable();
            this.fetchWardDropdownList(res.data[0].code);
          }
        }
      });
    }
  }

  createForm() {
    this.group = this.fb.group({
      contactLevelId: this.level,
      name: this.name,
      designationId: this.designation,
      address: this.address,
      officialEmail: this.officialEmail,
      officialMobile: this.officialMobile,
      officialLandline: this.officialLandline,
      personalEmail: this.personalEmail,
      personalMobile: this.personalMobile,
      whatsApp: this.whatsApp,
      facebook: this.facebook,
      twitter: this.twitter,
      linkedin: this.linkedin,
      instagram: this.instagram,
      message: this.message,
      photo: new FormControl(),
      stateId: this.state,
      districtId: this.district,
      ulbId: this.ulb,
      ward: this.ward,
      area: this.area,
      zoneId: this.zone,
    });
  }
  editForm() {
    this.isEditable = true;
    this.group.enable();
    this.util.toggleAccessControls(
      this.group.get("stateId"),
      this.group.get("districtId"),
      this.group.get("ulbId")
    );
  }
  submit() {
    if (this.group.valid) {
      const data = {
        contactLevelId: this.level.value,
        name: this.name.value,
        designationId: this.designation.value,
        designationName: this.designationOptions.find(
          (i) => i.designationId === this.designation.value
        )?.name,
        address: this.address.value,
        officialEmail: this.officialEmail.value,
        officialMobile: this.officialMobile.value,
        officialLandline: this.officialLandline.value,
        personalEmail: this.personalEmail.value,
        personalMobile: this.personalMobile.value,
        whatsApp: this.whatsApp.value,
        facebook: this.facebook.value,
        twitter: this.twitter.value,
        linkedin: this.linkedin.value,
        instagram: this.instagram.value,
        message: this.message.value,
        stateId: this.state.value,
        districtId: this.district.value,
        ulbId: this.ulb.value,
        wardId: this.ward.value,
        zoneId: this.zone.value,
        // areaId: this.area.value,
      };
      if (this.id) {
        this.city
          .update(this.baseUrl, this.id, this.util.nullCheckObj(data))
          .subscribe(
            (res) => {
              if (res.responseCode === 200) {
                this.util.showMsg("Updated Successfully");
                this.back(res.data);
              } else {
                this.util.showMsg(res.responseMessage, "Error");
              }
            },
            (err) => {
              this.util.errorMessage(err);
            }
          );
      } else {
        this.city.save(this.baseUrl, this.util.nullCheckObj(data)).subscribe(
          (res) => {
            if (res.responseCode === 200) {
              this.back(res.data);
              if (Object.keys(this.data).length) {
                return;
              }
              this.util.showMsg("Saved Successfully");
            } else {
              this.util.showMsg(res.responseMessage, "Error");
            }
          },
          (err) => {
            this.util.errorMessage(err);
          }
        );
      }
    } else {
      console.log("this.group",this.group);
      console.log(this.util.findInvalidControls(this.group));
    }
  }

  fetchAccessList() {
    this.http.accessLevelOptions().subscribe(
      (res) => {
        if (res) {
          this.accessOptions = res;
          this.accessOptions.map((item) => {
            if (this.util.getAccessLevel() === "ULB") {
              if (
                item.access === "NATIONAL" ||
                item.access === "STATE" ||
                item.access === "DISTRICT"
              ) {
                item.disable = true;
              }
            } else if (this.util.getAccessLevel() === "DISTRICT") {
              if (item.access === "NATIONAL" || item.access === "STATE") {
                item.disable = true;
              }
            } else if (this.util.getAccessLevel() === "STATE") {
              if (item.access === "NATIONAL") {
                item.disable = true;
              }
            } else {
              item.disable = false;
            }
          });
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  fetchWardDropdownList(id) {
    this.city.fetchWardDropdown(id).subscribe(
      (res) => {
        if (res.responseCode === 200) {
          this.wardOptions = res.data;
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  fetchAreaDropdownList(id) {
    this.city.fetchAreaDropdown(id).subscribe(
      (res) => {
        if (res.responseCode === 200) {
          this.areaOptions = res.data;
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  fetchZoneDropdownList(id) {
    this.city.fetchZoneDropdown(id).subscribe(
      (res) => {
        if (res.responseCode === 200) {
          this.zoneOptions = res.data;
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  fetchDesignationList(accessLevel = {}) {
    this.sys.fetchDesignationOptions(accessLevel).subscribe(
      (res) => {
        if (res.responseCode === 200) {
          this.designationOptions = res.data;
        }
      },
      (err) => {
        this.util.errorMessage(err);
      }
    );
  }

  setData(row) {
    this.level.setValue(row.contactLevelId);
    this.name.setValue(row.name);
    this.designation.setValue(row.designationId);
    this.ward.setValue(row.wardId);
    this.zone.setValue(row.zoneId);
    this.state.setValue(row.stateId);
    this.address.setValue(row.address);
    if (row.districtId) {
      this.district.setValue(row.districtId);
    }
    if (row.ulbId) {
      this.ulb.setValue(row.ulbId);
    }
    this.officialEmail.setValue(row.officialEmail);
    this.officialMobile.setValue(row.officialMobile);
    this.officialLandline.setValue(row.officialLandline);
    this.personalEmail.setValue(row.personalEmail);
    this.personalMobile.setValue(row.personalMobile);
    this.whatsApp.setValue(row.whatsApp);
    this.facebook.setValue(row.facebook);
    this.twitter.setValue(row.twitter);
    this.linkedin.setValue(row.linkedin);
    this.instagram.setValue(row.instagram);
    this.message.setValue(row.message);
    // this.photo.setValue(row.photo);
  }

  back(data = null) {
    if (this.data.title) {
      this.dialogRef.close(data);
    } else {
      this.router.navigate(["../"], { relativeTo: this.route });
    }
  }

  // To Set Width of the field
  getDynamicClass() {
    return this.isProfile ? "col-lg-12" : "col-lg-3";
  }
}
